import {
  GET_ONE_INVOICE,
  GET_ONE_INVOICE_SUCCESS,
  GET_ONE_INVOICE_ERROR,
  GET_ONE_INVOICE_SETTINGS,
  GET_ONE_INVOICE_SETTINGS_SUCCESS,
  GET_ONE_INVOICE_SETTINGS_ERROR,
  UPDATE_ONE_INVOICE_SETTINGS,
  UPDATE_ONE_INVOICE_SETTINGS_SUCCESS,
  UPDATE_ONE_INVOICE_SETTINGS_ERROR,
  RECORD_ONE_INVOICE_PAYMENT,
  RECORD_ONE_INVOICE_PAYMENT_ERROR,
  RECORD_ONE_INVOICE_PAYMENT_SUCCESS,
  DUPLICATE_ONE_INVOICE,
  DUPLICATE_ONE_INVOICE_SUCCESS,
  DUPLICATE_ONE_INVOICE_ERROR,
  SEND_INVOICE,
  SEND_INVOICE_SUCCESS,
  SEND_INVOICE_ERROR,
  SEND_RECEIPT,
  SEND_RECEIPT_SUCCESS,
  SEND_RECEIPT_ERROR,
  RESET_MESSAGE,
} from "../../actions";

const intialState = {
  getOneInvoiceLoading: false,
  updateOneInvoiceSettingLoading: false,
  updateOneInvoiceError: false,
  recordPaymentLoading: false,
  duplicateInvoiceLoading: false,
  sendInvoiceLoading: false,
  getOneInvoiceError: "",
  getOneInvoiceSettingError: "",
  updateOneInvoiceSettingError: "",
  recordPaymentError: "",
  duplicateInvoiceError: "",
  sendInvoiceError: "",
  sendReceiptError: "",
  details: {},
  message: {
    updateSettings: "",
    recordPayment: "",
    duplicateInvoice: "",
    getOneInvoice: "",
    sendInvoice: "",
    sendReceipt: "",
  },
  invoiceSetting: {},
};

const oneInvoiceReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_ONE_INVOICE:
      return {
        ...state,
        getOneInvoiceLoading: true,
      };
    case GET_ONE_INVOICE_SUCCESS:
      return {
        ...state,
        getOneInvoiceLoading: false,
        details: action.payload?.invoice,
        message: { ...state?.message, getOneInvoice: action?.payload?.message },
      };
    case GET_ONE_INVOICE_ERROR:
      return {
        ...state,
        getOneInvoiceLoading: false,
        getOneInvoiceError: action.payload,
      };

    case GET_ONE_INVOICE_SETTINGS:
      return {
        ...state,
      };
    case GET_ONE_INVOICE_SETTINGS_SUCCESS:
      return {
        ...state,
        invoiceSetting: action.payload,
      };
    case GET_ONE_INVOICE_SETTINGS_ERROR:
      return {
        ...state,
        getOneInvoiceSettingError: action?.payload,
      };
    case UPDATE_ONE_INVOICE_SETTINGS:
      return {
        ...state,
        updateOneInvoiceSettingLoading: true,
      };
    case UPDATE_ONE_INVOICE_SETTINGS_SUCCESS:
      return {
        ...state,
        updateOneInvoiceSettingLoading: false,
        message: { ...state?.message, updateSetting: action?.payload?.message },
        invoiceSetting: action?.payload?.data,
      };
    case UPDATE_ONE_INVOICE_SETTINGS_ERROR:
      return {
        ...state,
        updateOneInvoiceSettingLoading: false,
        updateOneInvoiceSettingError: action?.payload,
      };
    case RECORD_ONE_INVOICE_PAYMENT:
      return {
        ...state,
        recordPaymentLoading: true,
      };
    case RECORD_ONE_INVOICE_PAYMENT_SUCCESS:
      return {
        ...state,
        recordPaymentLoading: false,
        message: { ...state?.message, recordPayment: action?.payload },
      };
    case RECORD_ONE_INVOICE_PAYMENT_ERROR:
      return {
        ...state,
        recordPaymentLoading: false,
        recordPaymentError: action?.payload,
      };
    case DUPLICATE_ONE_INVOICE:
      return {
        ...state,
        duplicateInvoiceLoading: true,
      };
    case DUPLICATE_ONE_INVOICE_SUCCESS:
      return {
        ...state,
        duplicateInvoiceLoading: false,
        message: {
          ...state?.message,
          duplicateInvoice: action?.payload,
        },
      };
    case DUPLICATE_ONE_INVOICE_ERROR:
      return {
        ...state,
        duplicateInvoiceLoading: false,
        duplicateInvoiceError: "",
      };
    case SEND_INVOICE:
      return {
        ...state,
        sendInvoiceLoading: true,
      };
    case SEND_INVOICE_SUCCESS:
      return {
        ...state,
        sendInvoiceLoading: false,
        message: {
          ...state?.message,
          sendInvoice: action?.payload,
        },
      };
    case SEND_INVOICE_ERROR:
      return {
        ...state,
        sendInvoiceLoading: false,
        sendInvoiceError: action.payload,
      };
    case SEND_RECEIPT:
      return {
        ...state,
        sendReceiptLoading: true,
      };
    case SEND_RECEIPT_SUCCESS:
      return {
        ...state,
        sendReceiptLoading: false,
        message: {
          ...state?.message,
          sendReceipt: action?.payload,
        },
      };
    case SEND_RECEIPT_ERROR:
      return {
        ...state,
        sendReceiptLoading: false,
        sendReceiptError: action?.payload,
      };
    case RESET_MESSAGE:
      return {
        ...state,
        getOneInvoiceError: "",
        getOneInvoiceSettingError: "",
        updateOneInvoiceSettingError: "",
        recordPaymentError: "",
        duplicateInvoiceError: "",
        sendInvoiceError: "",
        message: {
          updateSettings: "",
          recordPayment: "",
          duplicateInvoice: "",
          getOneInvoice: "",
          sendInvoice: "",
        },
      };
    default:
      return state;
  }
};

export default oneInvoiceReducer;
